import styled from "styled-components";
import { V3Paragraph } from "../Typography";

export const V3ParagraphGrey35 = styled(V3Paragraph)`
    color: ${({ theme }) => theme.v3.colors.grey35};
`;
